var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-enter-tips-audio-without",class:{ 'c-enter-tips-audio-without--error': _vm.isErrorPage }},[_c('enter-tips-audio-with-out-btn',{attrs:{"is-error-page":_vm.isErrorPage},on:{"clicked":_vm.clicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }